import React, { useState } from 'react';

import jet from "@randajan/jet-core";

import { Block } from "@randajan/jet-react/dom/block";
import { Tile } from "@randajan/jet-react/dom/tile";
import { Article } from '../../../elements/Article/Article';


import "./B2X.scss";
import lang from '../../../config/lang';

export const B2X = (props)=>{
    const {} = props;
    const [ b2b, setB2b ] = useState(false);
    
    return (
        <Block className={jet.melt(["B2X", "block", "wall", b2b ? "b2b" : "b2c"], " ")} caption={lang.b2x}>
            <div className="tiles">
            <Tile onClick={_=>setB2b(false)} src={"/icons/home.svg"} caption={lang.b2c} className="home" />
            <Tile onClick={_=>setB2b(true)} src={"/icons/company.svg"} caption={lang.b2b} className="company" />
            </div>
            <div className="tabs">
                <div className="upline"/>
                <div className="grid">
                    <Article src="web-b2c"/>
                    <Article src="web-b2b"/>
                </div>
            </div>
        </Block>
    )
}

